
<div class="app-container">
  <header>
    <app-sales-header-v3  [hidden]="!showHeader" />
  </header>
  <main>
    <router-outlet />
  </main>
</div>
